import React, { useRef, useState, useEffect } from "react";
import "./Contact.css";
import DashSideBar from "../../shared/DashSideBar";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import axios from "axios";

function Contact() {
  const toast = useRef(null);
  const [contact, setContact] = useState({
    email: "",
    phoneNumber: "",
  });
  const isFetched = useRef(false);
  useEffect(() => {
    if (!isFetched.current) {
      fetchContact();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);
  const fetchContact = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Contacts"
      );

      if (response.data) {
        setContact({
          email: response.data.email || "",
          phoneNumber: response.data.phoneNumber || "",
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Could not fetch contact info",
        life: 3000,
      });
      console.error("Fetch error:", error);
    }
  };
  const handleChange = (e) => {
    setContact({ ...contact, [e.target.name]: e.target.value });
  };

  const saveContact = async () => {
    try {
      const payload = {
        Id: 1,
        Email: contact.email,
        PhoneNumber: contact.phoneNumber,
      };
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_URL + "api/Contacts/1",
        payload,
        {
          headers: {
            "Content-Type": "application/json", // ✅ Proper for JSON body
          },
        }
      );

      if (response.data) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Contact info saved",
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to save contact",
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred",
        life: 3000,
      });
      console.error(error);
    }
  };
  return (
    <div className="col-12 d-flex">
      <Toast ref={toast} />
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="contactdash-container">
          <div className="card">
            <h3 className="mb-3">Contact Info</h3>

            <div className="field mb-3">
              <label htmlFor="email" className="block mb-1">
                Email
              </label>
              <InputText
                id="email"
                name="email"
                value={contact.email}
                onChange={handleChange}
                className="w-full"
              />
            </div>

            <div className="field mb-3">
              <label htmlFor="phoneNumber" className="block mb-1">
                Phone Number
              </label>
              <InputText
                id="phoneNumber"
                name="phoneNumber"
                value={contact.phoneNumber}
                onChange={handleChange}
                className="w-full"
              />
            </div>

            <Button label="Save" icon="pi pi-save" onClick={saveContact} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
